module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "step3-form",
    style: ({
      minHeight: (_vm.screenHeight - 85) + 'px'
    })
  }, [(this.$route.query.yanse == 1) ? _c('div', {
    staticClass: "step-form__step-num2"
  }, [_vm._v("2/5")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2) ? _c('div', {
    staticClass: "step-form__step-num"
  }, [_vm._v("2/5")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__main"
  }, [_c('h1', {
    staticClass: "step-form__title"
  }, [_vm._v(_vm._s(this.$route.query.productName) + "-" + _vm._s(_vm.stepsTitle))]), _vm._v(" "), (!_vm.isaddBank) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showList),
      expression: "showList"
    }],
    staticClass: "bankcard-list-container"
  }, [_c('ul', {
    staticClass: "bankcard-list"
  }, [_vm._l((_vm.bankcardList_bl.bankList), function(item) {
    return _c('li', {
      key: item.bankAccountId,
      class: ['bankcard-list__list-item', item.selected ? 'is-selected' : ''],
      on: {
        "click": function($event) {
          return _vm.selectBankcard(item)
        }
      }
    }, [_c('div', {
      staticClass: "bankcard-list__list-item__btn-container"
    }, [_c('span', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.checkForm(item)
        }
      }
    }, [_vm._v("查看")])]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isReturnAcount && item.isPayAcount),
        expression: "item.isReturnAcount && item.isPayAcount"
      }],
      staticClass: "bankcard-list__list——custom"
    }, [_vm._v("回款专户")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isReturnAcount && item.isPayAcount),
        expression: "item.isReturnAcount && item.isPayAcount"
      }],
      staticClass: "bankcard-list__list——jscustom"
    }, [_vm._v("结算账户")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isReturnAcount && !item.isPayAcount),
        expression: "item.isReturnAcount && !item.isPayAcount"
      }],
      staticClass: "bankcard-list__list——jscustom-single"
    }, [_vm._v("回款专户")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.isReturnAcount && item.isPayAcount),
        expression: "!item.isReturnAcount && item.isPayAcount"
      }],
      staticClass: "bankcard-list__list——jscustom-single"
    }, [_vm._v("结算账户")]), _vm._v(" "), _c('h5', {
      staticClass: "bankcard-list__list-item__bank-name"
    }, [_vm._v(_vm._s(item.bankName))]), _vm._v(" "), _c('h6', {
      staticClass: "bankcard-list__list-item__branch-bank-name"
    }, [_vm._v(_vm._s(item.bankBranchName))]), _vm._v(" "), _c('div', {
      staticClass: "bankcard-list__list-item__bankcard-num"
    }, [_vm._v(_vm._s(_vm._f("replaceBankcardNumWithStar")(item.bankAccountName)) + "\n            ")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "bankcard-list__add",
    on: {
      "click": _vm.newForm
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showList),
      expression: "!showList"
    }],
    staticClass: "bankcard-form-container"
  }, [_c('el-row', {
    staticClass: "step-form__form",
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "bankcardForm",
    attrs: {
      "label-width": '50%',
      "model": _vm.bankcardForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开户名称"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": true,
      "placeholder": "请输入开户名称"
    },
    model: {
      value: (_vm.bankcardForm.bankUserName),
      callback: function($$v) {
        _vm.$set(_vm.bankcardForm, "bankUserName", $$v)
      },
      expression: "bankcardForm.bankUserName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行所属区域"
    }
  }, [(_vm.regionData) ? _c('el-cascader', {
    attrs: {
      "options": _vm.regionData,
      "props": _vm.bankRegionProps,
      "disabled": true,
      "placeholder": "请选择银行所属区域"
    },
    model: {
      value: (_vm.bankcardForm.bankRegion),
      callback: function($$v) {
        _vm.$set(_vm.bankcardForm, "bankRegion", $$v)
      },
      expression: "bankcardForm.bankRegion"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchBankName,
      "disabled": true,
      "placeholder": "请输入开户银行"
    },
    model: {
      value: (_vm.bankcardForm.bankName),
      callback: function($$v) {
        _vm.$set(_vm.bankcardForm, "bankName", $$v)
      },
      expression: "bankcardForm.bankName"
    }
  }, _vm._l((_vm.bankNameData), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支行名称"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": true,
      "placeholder": "请输入支行名称"
    },
    model: {
      value: (_vm.bankcardForm.bankBranchName),
      callback: function($$v) {
        _vm.$set(_vm.bankcardForm, "bankBranchName", $$v)
      },
      expression: "bankcardForm.bankBranchName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行行号",
      "prop": "bankSwift"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": true,
      "placeholder": "请输入开户行行号",
      "maxlength": 35
    },
    model: {
      value: (_vm.bankcardForm.bankSwift),
      callback: function($$v) {
        _vm.$set(_vm.bankcardForm, "bankSwift", $$v)
      },
      expression: "bankcardForm.bankSwift"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户账户"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": true,
      "placeholder": "请输入开户账户"
    },
    model: {
      value: (_vm.bankcardForm.bankAccountName),
      callback: function($$v) {
        _vm.$set(_vm.bankcardForm, "bankAccountName", $$v)
      },
      expression: "bankcardForm.bankAccountName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账户类型",
      "prop": "bankUseTypeArr"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.bankcardForm.bankUseTypeArr),
      callback: function($$v) {
        _vm.$set(_vm.bankcardForm, "bankUseTypeArr", $$v)
      },
      expression: "bankcardForm.bankUseTypeArr"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "0",
      "disabled": true
    }
  }, [_vm._v("回款专户")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "1",
      "disabled": true
    }
  }, [_vm._v("结算账户")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.showList) ? _c('div', {
    staticClass: "step-form__btn-container"
  }, [(this.$route.query.yanse == 1) ? _c('button', {
    staticClass: "step-form__btn-prev2",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 1) ? _c('button', {
    staticClass: "step-form__btn-next2",
    attrs: {
      "element-loading-text": "Loading"
    },
    on: {
      "click": _vm.goNext
    }
  }, [_vm._v("下一步")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2) ? _c('button', {
    staticClass: "step-form__btn-prev",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2) ? _c('button', {
    staticClass: "step-form__btn-next",
    attrs: {
      "element-loading-text": "Loading"
    },
    on: {
      "click": _vm.goNext
    }
  }, [_vm._v("下一步")]) : _vm._e()]) : _c('div', {
    staticClass: "step-form__btn-container"
  }, [_c('button', {
    staticClass: "step-form__btn-next",
    on: {
      "click": function($event) {
        return _vm.closeCard()
      }
    }
  }, [_vm._v("取消")])])]) : _vm._e(), _vm._v(" "), (_vm.isaddBank) ? _c('div', {
    staticClass: "addBank"
  }, [_c('div', {
    staticClass: "bankcard-form-container"
  }, [_c('el-row', {
    staticClass: "personal-center-form__form",
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "bankcardForm",
    staticStyle: {
      "margin-left": "-180px"
    },
    attrs: {
      "label-width": '50%',
      "model": _vm.bankcardForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开户名称"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.isaddBank,
      "placeholder": "请输入开户名称",
      "maxlength": 35
    },
    model: {
      value: (_vm.bankcardForm.bankUserName),
      callback: function($$v) {
        _vm.$set(_vm.bankcardForm, "bankUserName", $$v)
      },
      expression: "bankcardForm.bankUserName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行所属区域",
      "prop": "bankRegion"
    }
  }, [(_vm.regionData) ? _c('el-cascader', {
    attrs: {
      "options": _vm.regionData,
      "props": _vm.bankRegionProps,
      "disabled": !_vm.isaddBank,
      "placeholder": "请选择银行所属区域"
    },
    on: {
      "active-item-change": _vm.changeRegionData
    },
    model: {
      value: (_vm.bankcardForm.bankRegion),
      callback: function($$v) {
        _vm.$set(_vm.bankcardForm, "bankRegion", $$v)
      },
      expression: "bankcardForm.bankRegion"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行",
      "prop": "bankName"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchBankName,
      "disabled": !_vm.isaddBank,
      "placeholder": "请输入关键字选择开户银行,如“顺德农商”"
    },
    on: {
      "change": _vm.changeBankName,
      "focus": function($event) {
        return _vm.showBankCardTips()
      }
    },
    model: {
      value: (_vm.bankcardForm.bankName),
      callback: function($$v) {
        _vm.$set(_vm.bankcardForm, "bankName", $$v)
      },
      expression: "bankcardForm.bankName"
    }
  }, _vm._l((_vm.bankNameData), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行行号",
      "prop": "bankSwift"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.isaddBank,
      "placeholder": "请输入开户行行号",
      "maxlength": 35
    },
    model: {
      value: (_vm.bankcardForm.bankSwift),
      callback: function($$v) {
        _vm.$set(_vm.bankcardForm, "bankSwift", $$v)
      },
      expression: "bankcardForm.bankSwift"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支行名称",
      "prop": "bankBranchName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.isaddBank,
      "placeholder": "请输入支行名称",
      "maxlength": 35
    },
    model: {
      value: (_vm.bankcardForm.bankBranchName),
      callback: function($$v) {
        _vm.$set(_vm.bankcardForm, "bankBranchName", $$v)
      },
      expression: "bankcardForm.bankBranchName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户账户",
      "prop": "bankAccountName"
    }
  }, [(_vm.isShowFormatBANBox) ? _c('div', {
    staticClass: "showFormatBankAccountName"
  }, [_c('span', [_vm._v(_vm._s(_vm.bankAccountNameSpace))])]) : _vm._e(), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.isaddBank,
      "maxlength": 23,
      "placeholder": "请输入开户账户"
    },
    on: {
      "input": _vm.addBankcardNumSpaces,
      "focus": _vm.showFormatBANBox
    },
    model: {
      value: (_vm.bankcardForm.bankAccountName),
      callback: function($$v) {
        _vm.$set(_vm.bankcardForm, "bankAccountName", $$v)
      },
      expression: "bankcardForm.bankAccountName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账户类型",
      "prop": "bankUseTypeArr"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.bankcardForm.bankUseTypeArr),
      callback: function($$v) {
        _vm.$set(_vm.bankcardForm, "bankUseTypeArr", $$v)
      },
      expression: "bankcardForm.bankUseTypeArr"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "0",
      "disabled": !_vm.isaddBank
    }
  }, [_vm._v("回款专户")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "1",
      "disabled": !_vm.isaddBank
    }
  }, [_vm._v("结算账户")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.isaddBank) ? _c('el-button', {
    staticClass: "personal-center-form__submit",
    staticStyle: {
      "background": "#EB662B"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmitting
    },
    on: {
      "click": _vm.saveBankcard
    }
  }, [_vm._v("\n            确定\n          ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "personal-center-form__submit",
    staticStyle: {
      "background": "#EB662B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.hideForm
    }
  }, [_vm._v("\n            返回\n          ")])], 1)]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    staticClass: "success-modal",
    attrs: {
      "top": "23%",
      "visible": _vm.gylSuccessModal.show,
      "before-close": _vm.beforeCloseGylSuccessModal,
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.closeGylSuccessModal
    }
  }, [_c('div', {
    staticClass: "success-modal__text"
  }, [_vm._v(_vm._s(_vm.gylSuccessModal.content))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bb9c719"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/applyLoan/Step3_bak_bl.vue
// module id = 1067
// module chunks = 1